export class CopyValueBtn {
    static successClass = 'copyValue--copied';
    static failureClass = 'copyValue--failed';
    static feedbackMs = 1200;

    /**
     *
     * @param {String} btnClass
     * @param {String} valueClass
     * @param {String} parentSelector JS element selector (Example: ".class", "#id" etc.)
     */
    constructor(btnClass='copyValue', valueClass='valueContainer', parentSelector = 'div') {
        this.btnClass = btnClass;
        this.buttonSelector = `.${btnClass}`;
        this.parentSelector = parentSelector;
        this.valueClass = valueClass;
        this.initActions();
    }

    initActions(){
        $('body')
            .off(`click.copy-value-btn-${this.btnClass}`, this.buttonSelector)
            .on(`click.copy-value-btn-${this.btnClass}`, this.buttonSelector, (e) => {
                e.preventDefault();

                const button = e.currentTarget;
                const value = this.getCopyValue(button);
                const source = this.getCopySource(button);

                if (!value) {
                    return;
                }

                this.copyText(value, source)
                    .then(() => {
                        this.showButtonFeedback(
                            button,
                            '<span class="copyValue__feedback"><span class="copyValue__check" aria-hidden="true">✓</span> Copied</span>',
                            CopyValueBtn.successClass
                        );
                        this.showCopiedMessage();
                    })
                    .catch((error) => {
                        this.showCopyFailed(button);
                        console.error('Copy failed', error);
                    });
            });
    }

    getCopyValue(button) {
        const dataValue = button.dataset.copyValue;

        if (dataValue) {
            return dataValue.trim();
        }

        const parent = $(button).closest(this.parentSelector);
        const value = parent.find(`.${this.valueClass}`).first();

        if (!value.length) {
            return '';
        }

        return (value.val() || value.attr('href') || value.text() || '').trim();
    }

    getCopySource(button) {
        return $(button)
            .closest(this.parentSelector)
            .find(`.${this.valueClass}`)
            .first()[0] || null;
    }

    copyText(value, source) {
        if (window.navigator.clipboard && window.isSecureContext) {
            return window.navigator.clipboard.writeText(value)
                .catch(() => this.copySelectedElement(source))
                .catch(() => this.copyTextWithFallback(value));
        }

        return this.copySelectedElement(source)
            .catch(() => this.copyTextWithFallback(value));
    }

    copySelectedElement(source) {
        return new Promise((resolve, reject) => {
            if (!source) {
                reject(new Error('No visible copy source found'));
                return;
            }

            const range = document.createRange();
            const selection = window.getSelection();

            range.selectNodeContents(source);
            selection.removeAllRanges();
            selection.addRange(range);

            try {
                const copied = document.execCommand('copy');
                selection.removeAllRanges();
                copied ? resolve() : reject(new Error('Visible copy command was rejected'));
            } catch (error) {
                selection.removeAllRanges();
                reject(error);
            }
        });
    }

    copyTextWithFallback(value) {
        return new Promise((resolve, reject) => {
            const textarea = document.createElement('textarea');
            textarea.value = value;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.top = '-1000px';
            textarea.style.left = '-1000px';
            textarea.style.opacity = '0';

            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();

            try {
                const copied = document.execCommand('copy');
                document.body.removeChild(textarea);
                copied ? resolve() : reject(new Error('Copy command was rejected'));
            } catch (error) {
                document.body.removeChild(textarea);
                reject(error);
            }
        });
    }

    showCopiedMessage() {
        $('#codeCopyMessage').css('z-index',100).css('opacity', 1);
        $('#codeCopyMessage').fadeIn(300, () => {
                setTimeout(() => {
                    $('#codeCopyMessage').fadeOut(300);
                }, 3000);
        });
    }

    showCopyFailed(button) {
        this.showButtonFeedback(button, 'Copy failed', CopyValueBtn.failureClass);
    }

    showButtonFeedback(button, html, className) {
        const originalHtml = button.innerHTML;
        button.style.minWidth = `${button.offsetWidth}px`;
        button.classList.remove(CopyValueBtn.successClass, CopyValueBtn.failureClass);
        button.classList.add(className);
        button.innerHTML = html;
        button.disabled = true;

        setTimeout(() => {
            button.innerHTML = originalHtml;
            button.classList.remove(CopyValueBtn.successClass, CopyValueBtn.failureClass);
            button.style.minWidth = '';
            button.disabled = false;
        }, CopyValueBtn.feedbackMs);
    }
}
